module.exports = __webpack_public_path__ + "static/_/src/config/PsMusicConfig/musics//5. Zabawy z mama i tata.mp3";